<template>
    <div class="product-hierarchy">
        <div
              v-if="result._source.MixedCaseType === ''"
            >
              <a
                v-if="result._source.Country[0]"
                @click="
                  $emit('set-filter', {field: 'Country', term: result._source.Country[0]})
                "
                >{{ result._source.Country[0] }}</a
              >
              <a
                v-if="result._source.Region[0]"
                @click="$emit('set-filter', {field: 'Region', term: result._source.Region[0]})"
                >{{ result._source.Region[0] }}</a
              >
              <a
                v-if="result._source.SubRegion[0]"
                @click="
                  $emit('set-filter', {field: 'SubRegion', term: result._source.SubRegion[0]})
                "
                >{{ result._source.SubRegion[0] }}</a
              >
            </div>

            <div v-else>Mixed Case</div>
    </div>
</template>


<script>
    export default {
      props: {
        result: {
          type: [Boolean, Object],
          default: false
        }
      }
    }
</script>
